import { Injectable } from '@angular/core';
import { OnlineInterfaceService } from '../online-interface-service/online-interface.service';
import { StorageService } from '../storege-service/storage.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService {

  constructor(
    private storageSrv: StorageService,
    private onlineInterfaceSrv: OnlineInterfaceService,) { }



  getCourts = async(facilityId) => {
    const courts=this.storageSrv.getCourtsGlobal() 
    
    if(!courts){
      const updatedCourts=await this.onlineInterfaceSrv.getCourts(facilityId)
      const frozenData = Object.freeze(updatedCourts);
      this.storageSrv.setCourtsGlobal(JSON.stringify(frozenData))
      return updatedCourts
    }
  
  return courts
  }


  getBookingCategory = async(facilityId) => {
    const bookingCategories=this.storageSrv.getBookingCategoryGlobal() 
    
    if(!bookingCategories){
      const updatedBookingCategories=await this.onlineInterfaceSrv.getBookingCategory(facilityId)
      const frozenData = Object.freeze(updatedBookingCategories);
      this.storageSrv.setBookingCategoryGlobal(JSON.stringify(frozenData))
      return updatedBookingCategories
    }
  
  return bookingCategories
  }


  getAddonsTable = async(facilityId) => {
    const addonsTable=this.storageSrv.getAddonsTableGlobal() 
    
    if(!addonsTable){
      const updatedAddonsTable=await this.onlineInterfaceSrv.getAddonsTable(facilityId)
      const frozenData = Object.freeze(updatedAddonsTable);
      this.storageSrv.setAddonsTableGlobal(JSON.stringify(frozenData))
      return updatedAddonsTable
    }
  
  return addonsTable
  }


  getCourtsCalendar = async(facilityId) => {
    const courtsCalendar=this.storageSrv.getCourtsCalendarGlobal() 
    
    if(!courtsCalendar){
      const updatedCourtsCalendar=await this.onlineInterfaceSrv.getCourtsCalendar(facilityId)
      const frozenData = Object.freeze(updatedCourtsCalendar);
      this.storageSrv.setCourtsCalendarGlobal(JSON.stringify(frozenData))
      return updatedCourtsCalendar
    }
  
  return courtsCalendar
  }



  getCoachesByFacility = async() => {
    const coachesByFacility=this.storageSrv.getCoachesByFacilityGlobal() 
    
    if(!coachesByFacility){
      const updatedCoachesByFacility=await this.onlineInterfaceSrv.getCoachesByFacility()
      const frozenData = Object.freeze(updatedCoachesByFacility);
      this.storageSrv.setCoachesByFacilityGlobal(JSON.stringify(frozenData))
      return updatedCoachesByFacility
    }
  
  return coachesByFacility
  }


  getPaymentMethods= async(facilityId) => {
    const paymentMethods=this.storageSrv.getPaymentMethodsGlobal() 
    
    if(!paymentMethods){
      const updatedPaymentMethods=await this.onlineInterfaceSrv.getPaymentMethods(facilityId)
      const frozenData = Object.freeze(updatedPaymentMethods);
      this.storageSrv.setPaymentMethodsGlobal(JSON.stringify(frozenData))
      return updatedPaymentMethods
    }
  
  return paymentMethods
  }


  getTimingSlots= async(facilityId) => {
    const timingSlots=this.storageSrv.getTimingSlotsGlobal() 
    
    if(!timingSlots){
      const updatedTimingSlots=await this.onlineInterfaceSrv.getTimingSlots(facilityId)
      const frozenData = Object.freeze(updatedTimingSlots);
      this.storageSrv.setTimingSlotsGlobal(JSON.stringify(frozenData))
      return updatedTimingSlots
    }
  
  return timingSlots
  }

  getAddons = async(facilityId) => {
    const addonsTable=this.storageSrv.getAddonsTableGlobal() 
    
    if(!addonsTable){
      const updatedAddonsTable=await this.onlineInterfaceSrv.getAddons(facilityId)
      const frozenData = Object.freeze(updatedAddonsTable);
      this.storageSrv.setAddonsTableGlobal(JSON.stringify(frozenData))
      return updatedAddonsTable
    }
  
  return addonsTable
  }

  getReportTypes=async(facilityId)=>{
    const reportTypes=this.storageSrv.getReportTypesGlobal() 
    if(!reportTypes){
      const updatedReportTypes=await this.onlineInterfaceSrv.getReportsTypes(facilityId)
      const frozenData = Object.freeze(updatedReportTypes);
      this.storageSrv.setAddonsTableGlobal(JSON.stringify(frozenData))
      return updatedReportTypes
    }
  
  return reportTypes
  }


  removeGlobalSettings=()=>{
    this.storageSrv.removeGlobalSettings()
  }

  loadGlobalSettings=async(facilityId)=>{
    await this.getCourts(facilityId)
    await this.getBookingCategory(facilityId)
    await this.getAddonsTable(facilityId)
    await this.getCourtsCalendar(facilityId)
    await this.getCoachesByFacility()
    await this.getPaymentMethods(facilityId)
    await this.getTimingSlots(facilityId)
    await this.getAddons(facilityId)

  }

}
